import { HttpClient } from '../../protocols/http/httpClient'
import { IGetRoles, Role } from '../../../domain/usecases/Roles'

export class RemoteGetRoles implements IGetRoles {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async getRoles(companyId: string): Promise<Role[]> {
    try {
      // Try to get company roles (includes system + custom roles)
      console.log(
        '[RemoteGetRoles] Fetching company roles from:',
        `${this.url}/roles/company`
      )
      const httpResponse = await this.httpClient.get?.({
        url: `${this.url}/roles/company`
      })

      console.log('[RemoteGetRoles] Company roles response:', httpResponse)

      // API returns {systemRoles: [...], customRoles: [...]}
      if (httpResponse && httpResponse.systemRoles) {
        const allRoles = [
          ...httpResponse.systemRoles
            .filter((role: any) => role.name !== 'admin') // Filter out super admin role
            .map((role: any) => ({
              ...role,
              is_system: true
            })),
          ...httpResponse.customRoles
        ]
        console.log('[RemoteGetRoles] Returning combined roles:', allRoles)
        return allRoles
      }

      // API might return {data: [...], pagination: {...}}, extract the data array
      if (
        httpResponse &&
        httpResponse.data &&
        Array.isArray(httpResponse.data)
      ) {
        console.log('[RemoteGetRoles] Returning data array:', httpResponse.data)
        return httpResponse.data
      }

      // Or it might return the array directly
      if (Array.isArray(httpResponse)) {
        console.log(
          '[RemoteGetRoles] Returning response directly:',
          httpResponse
        )
        return httpResponse
      }

      console.log('[RemoteGetRoles] Response not an array, checking structure')
    } catch (error) {
      console.error(
        '[RemoteGetRoles] Error fetching company roles, falling back to system roles:',
        error
      )

      // Fallback: get only system roles (no permission required)
      try {
        console.log(
          '[RemoteGetRoles] Fetching system roles from:',
          `${this.url}/roles/system`
        )
        const systemRolesResponse = await this.httpClient.get?.({
          url: `${this.url}/roles/system`
        })

        console.log(
          '[RemoteGetRoles] System roles response:',
          systemRolesResponse
        )

        if (
          systemRolesResponse &&
          systemRolesResponse.data &&
          Array.isArray(systemRolesResponse.data)
        ) {
          console.log(
            '[RemoteGetRoles] Returning system roles data array:',
            systemRolesResponse.data
          )
          return systemRolesResponse.data
        }

        if (Array.isArray(systemRolesResponse)) {
          console.log(
            '[RemoteGetRoles] Returning system roles directly:',
            systemRolesResponse
          )
          return systemRolesResponse
        }
      } catch (fallbackError) {
        console.error(
          '[RemoteGetRoles] Error fetching system roles:',
          fallbackError
        )
      }
    }

    console.log('[RemoteGetRoles] Returning empty array')
    return []
  }
}
